/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Verify_CtaInputs */

const en_pc_dl_verify_cta = /** @type {(inputs: Pc_Dl_Verify_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open SHA256SUMS.txt`)
};

const zh_pc_dl_verify_cta = /** @type {(inputs: Pc_Dl_Verify_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 SHA256SUMS.txt`)
};

/**
* | output |
* | --- |
* | "Open SHA256SUMS.txt" |
*
* @param {Pc_Dl_Verify_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_verify_cta = /** @type {((inputs?: Pc_Dl_Verify_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Verify_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_verify_cta(inputs)
	return zh_pc_dl_verify_cta(inputs)
});
export { pc_dl_verify_cta as "pc.dl.verify_cta" }